export default {
  title: "Contact Form",
  body: "Please fill out this form and we'll be in touch.",
  url: "https://go.8451.com/l/77612/2021-05-14/b4snl4"
}
